<template>
  <Form ref="loginForm" :model="form" :rules="rules">
    <FormItem prop="userName">
      <Input v-model="form.userName" placeholder="请输入邮箱登录账号">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="password">
      <Input type="password" v-model="form.password" placeholder="请输入密码">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
    <div class="checkbox checkbox-css m-b-30">
      <input type="checkbox" id="remember_me_checkbox" value />
      <label for="remember_me_checkbox">记住我</label>
    </div>
    <p class="text-center text-grey-darker">&copy; 南京**信息科技有限公司 All Right Reserved 2019</p>
    <p class="text-center text-grey-darker">&copy; 支持 chrome、safari、ie11等 浏览器</p>
  </Form>
</template>
<script>
import { getCookie, setCookie } from "@/libs/util";

export default {
  name: "LoginForm",

  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: "邮箱账号不能为空", trigger: "blur" }
        ];
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "密码不能为空", trigger: "blur" }];
      }
    }
  },
  data() {
    return {
      form: {
        userName: getCookie("loginEmail"),
        password: ""
      }
    };
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules
      };
    }
  },
  methods: {
    handleSubmit() {
      setCookie("loginEmail", this.form.userName);
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$emit("on-success-valid", {
            userName: this.form.userName,
            password: this.form.password
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-form-item {
  margin-bottom: 24px;
}
</style>
